export const routes = (prefix = `appointments`) => [
    {
        name: `${prefix}.index`,
        path: `/${prefix}`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.index`,
                PageDescription: "Appointments: Consultant appointments",
            },
        },
    },
    {
        name: `${prefix}.create`,
        path: `/${prefix}/:patientID`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.index`,
                PageDescription: "Appointments: Consultant appointments",
            },
        },
    },
    {
        name: `${prefix}.print`,
        path: `/${prefix}/print/all`,
        component: () => import('./print/Appointments.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.index`,
                PageDescription: "Appointments: Consultant appointments",
            },
        },
    },
    {
        name: `${prefix}.print-details`,
        path: `/${prefix}/print/details`,
        component: () => import('./print/AppointmentDetails.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.index`,
                PageDescription: "Appointments: Consultant appointments",
            },
        },
    },
];
